import { useState } from "react";
import { Button } from "./ui/button";
import { Popover, PopoverTrigger, PopoverContent } from "./ui/popover";
import { Command, CommandInput, CommandList, CommandEmpty, CommandGroup, CommandItem } from "./ui/command";
import { ChevronsUpDown, Check } from "lucide-react";

export function ArticlePicker({ articles, value, onChange, placeholder = "Choisir un article...", testId }) {
  const [open, setOpen] = useState(false);
  const selected = articles.find((a) => a.id === value);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          type="button" variant="outline" role="combobox" aria-expanded={open}
          data-testid={testId} className="w-full justify-between font-normal"
        >
          <span className="truncate">{selected ? selected.nom : <span className="text-muted-foreground">{placeholder}</span>}</span>
          <ChevronsUpDown size={14} className="shrink-0 opacity-50" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-[--radix-popover-trigger-width] p-0">
        <Command>
          <CommandInput placeholder="Rechercher un article..." data-testid={testId ? `${testId}-search` : undefined} />
          <CommandList>
            <CommandEmpty>Aucun article trouvé.</CommandEmpty>
            <CommandGroup>
              {articles.map((a) => (
                <CommandItem
                  key={a.id} value={a.nom}
                  onSelect={() => { onChange(a.id); setOpen(false); }}
                  data-testid={testId ? `${testId}-option-${a.id}` : undefined}
                >
                  <Check size={14} className={`mr-2 ${value === a.id ? "opacity-100" : "opacity-0"}`} />
                  <span className="truncate">{a.nom}</span>
                  <span className="ml-auto text-xs text-muted-foreground shrink-0">Qté: {a.quantite}</span>
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
